// extracted by mini-css-extract-plugin
module.exports = {"navigation-link":"lPSFedbBf65L8YHuLGv1"};